import { MissionStatusEnum } from '../../types/enums/mission/mission-status.enum'
import { AccomodationCategoryEnum } from '../../types/enums/product/accomodation-category.enum'
import { StaffPositionEnum } from '../../types/enums/staff/staff-position.enum'
import { StaffQualificationEnum } from '../../types/enums/staff/staff-qualifications.enum'
import { StaffRequestFilters } from '../../types/models/staff-request/staff-request-input'

export const transformStaffRequestFiltersToUrl = (filters?: StaffRequestFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.countries && filters.countries.length)
    searchParams.append('countries', filters.countries.join(','))

  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))
  if (filters.formulas && filters.formulas.length)
    searchParams.append('formulas', filters.formulas.join(','))

  if (filters.qualifications && filters.qualifications.length)
    searchParams.append('qualifications', filters.qualifications.join(','))

  if (filters.accomodationCategory)
    searchParams.append('accomodationCategory', filters.accomodationCategory)

  if (filters.status && filters.status.length)
    searchParams.append('status', filters.status.join(','))

  if (filters.positions && filters.positions.length)
    searchParams.append('positions', filters.positions.join(','))

  if (filters.startDate) searchParams.append('startDate', filters.startDate)
  if (filters.endDate) searchParams.append('endDate', filters.endDate)
  if (filters.duration) searchParams.append('duration', filters.duration.toString())
  if (filters.centerIds) searchParams.append('centerIds', filters.centerIds.join(','))
  if (filters.radId) searchParams.append('radId', filters.radId.toString())
  if (filters.excludedStaffRequestId)
    searchParams.append('excludedStaffRequestId', filters.excludedStaffRequestId.toString())
  if (filters.includeCenter) searchParams.append('includeCenter', filters.includeCenter.toString())
  if (filters.hideFinishedStays) searchParams.append('hideFinishedStays', 'true')

  return searchParams.toString()
}

export const transformUrlToStaffRequestFilters = (
  searchParams: URLSearchParams
): StaffRequestFilters => {
  const filters: StaffRequestFilters = {}

  const countries = searchParams.get('countries')
  if (countries && countries.length) filters.countries = countries.split(',')

  const periods = searchParams.get('periods')
  if (periods && periods.length) filters.periods = periods.split(',')

  const formulas = searchParams.get('formulas')
  if (formulas && formulas.length)
    filters.formulas = formulas.split(',').map((formula) => parseInt(formula))

  const qualifications = searchParams.get('qualifications')
  if (qualifications && qualifications.length)
    filters.qualifications = qualifications.split(',') as StaffQualificationEnum[]

  const accomodationCategory = searchParams.get('accomodationCategory')
  if (accomodationCategory && accomodationCategory.length)
    filters.accomodationCategory = accomodationCategory as AccomodationCategoryEnum

  const status = searchParams.get('status')
  if (status && status.length) filters.status = status.split(',') as MissionStatusEnum[]

  const positions = searchParams.get('positions')
  if (positions && positions.length)
    filters.positions = positions.split(',') as StaffPositionEnum[]

  const startDate = searchParams.get('startDate')
  if (startDate && startDate.length) filters.startDate = startDate

  const endDate = searchParams.get('endDate')
  if (endDate && endDate.length) filters.endDate = endDate

  const duration = searchParams.get('duration')
  if (duration && duration.length) filters.duration = parseInt(duration)

  const centerIds = searchParams.get('centerIds')
  if (centerIds && centerIds.length)
    filters.centerIds = centerIds.split(',').map((centerId) => parseInt(centerId))

  const radId = searchParams.get('radId')
  if (radId && radId.length) filters.radId = parseInt(radId)

  const excludedStaffRequestId = searchParams.get('excludedStaffRequestId')
  if (excludedStaffRequestId && excludedStaffRequestId.length)
    filters.excludedStaffRequestId = parseInt(excludedStaffRequestId)

  const includeCenter = searchParams.get('includeCenter')
  if (includeCenter && includeCenter.length) {
    const normalizedIncludeCenter = includeCenter.toLowerCase()
    if (normalizedIncludeCenter === 'true') filters.includeCenter = true
    else if (normalizedIncludeCenter === 'false') filters.includeCenter = false
  }

  const hideFinishedStays = searchParams.get('hideFinishedStays')
  if (hideFinishedStays) filters.hideFinishedStays = hideFinishedStays === 'true'

  return filters
}
